export function handleAccordionClick(parent_id, element) {
	var accordion = document.getElementById(parent_id);
	if (!accordion) return;
	var accordion_items = document.getElementsByClassName('accordion-item');
	for (var i=0;accordion_items[i]; i++ ) {
		accordion_items[i].classList.remove('is-active');
	}
	element.parentNode.classList.add('is-active');
}